module.exports = __webpack_public_path__ + "img/sanvalentino.26f53219.jpeg";